import { baseBackend } from "../../../../../../api/base/baseUrl";
import { URL_DRIVER_COMMENTS } from "./endpoints";

export const getDriverCommentByBooking = async (counterBooking) => {
  return await baseBackend.get(`${URL_DRIVER_COMMENTS}/booking/${counterBooking}`);
};

export const createDriverComment = async (driverComment) => {
  return await baseBackend.post(
    URL_DRIVER_COMMENTS,
    JSON.stringify(driverComment),
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

export const updateDriverComment = async (driverComment) => {
  return await baseBackend.put(
    URL_DRIVER_COMMENTS,
    JSON.stringify(driverComment),
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};
